import React from 'react';
import { Box, Grid } from '@material-ui/core';

import { LargeSectionHeader } from 'components/Typography';
import { HeaderPropsType } from 'containers/PasswordRecoveryPages/types';
import { StyledShortBody } from 'containers/PasswordRecoveryPages/Header/styles';

const Header = ({ title, subTitle }: HeaderPropsType) => (
  <Box paddingY={2} paddingX={[2, 4, 8]}>
    <Grid container direction="row" alignItems="flex-end">
      <LargeSectionHeader weight="500">{title}</LargeSectionHeader>
    </Grid>
    <StyledShortBody>{subTitle}</StyledShortBody>
  </Box>
);

export default Header;
